import * as angular from "angular";
import {IController} from "angular";

export class AddressResolverEditFormCtrl implements IController {
  public originalAddress: any;
  public validatedAddress: any;
  public address: any;

  showEditResults: boolean;
  addressId: string;
  exactAddressResolution: boolean;
  servicesList: any[];
  ordersList: any[];
  onToggleExactAddressResolution: Function;
  onCityCheckChange: Function;
  onStreetCheckChange: Function;
  onValidatedAddressChange: Function;
  onCancel: Function;
  onUpdateServiceAndAccountsToggle: Function;


  constructor() {
  }

  $onInit() {
    this.getChangedValues();
  }

  getChangedValues(): string[] {
    const changedValues: string[] = [];
    if (this.originalAddress.city !== this.validatedAddress.city) {
      changedValues.push('city');
    }
    if (this.originalAddress.street !== this.validatedAddress.street) {
      changedValues.push('street');
    }
    return changedValues;
  }
}

angular
  .module('bringoz.admin.addresses')
  .component('addressResolverEditForm', {
    bindings: {
      address: '<',
      addressId: '<',
      originalAddress: '<',
      validatedAddress: '<',
      showEditResults: '<',
      exactAddressResolution: '<',
      servicesList: '<',
      ordersList: '<',
      onValidatedAddressChange: '&',
      onToggleExactAddressResolution: '&',
      onCityCheckChange: '&',
      onStreetCheckChange: '&',
      onCancel: '&',
      onUpdateServiceAndAccountsToggle: '&',
    },
    template: require('./address-resolver-edit-form.html').default,
    controller: AddressResolverEditFormCtrl
  });
